import React from 'react';
import styled from '@emotion/styled';

import { Container, Col, Row } from '@/components/grid';
import { H3 } from '@/components/type';
import { BREAKPOINTS, SPACE } from '@/constants';
import AccordionFaq from '@/components/accordion/accordionFaq';
import type { HsiycAccordionBlock } from '@tac/sanity-client/types';
import { type Dereference } from '@tac/sanity-client/type-utils';

const StyledContainer = styled(Container)`
  &.MuiContainer-root {
    padding-bottom: ${SPACE.X2};
    padding-top: ${SPACE.X2};

    @media (min-width: ${BREAKPOINTS.LG}) {
      padding-bottom: ${SPACE.X3};
      padding-top: ${SPACE.X3};
    }
  }
`;

const StyledCol = styled(Col)`
  text-align: center;
`;

const StyledH3 = styled(H3)`
  margin-bottom: calc(${SPACE.X1} + ${SPACE.X0});
`;

const StyledRichText = styled.div`
  margin-bottom: ${SPACE.X2};
`;

const colWidth = { xs: 12, lg: 10, xl: 8 };
const colOffset = [0, 0, 0, 1 / 12, 2 / 12];

const AccordionBlock = ({ heading, body, accordionItems = [] }: Dereference<HsiycAccordionBlock>) => {
  return (
    <StyledContainer>
      <Row>
        <StyledCol width={colWidth} offset={colOffset}>
          {heading && <StyledH3 as="h2">{heading}</StyledH3>}
          {body && <StyledRichText>{body}</StyledRichText>}
        </StyledCol>
        <Col width={colWidth} offset={colOffset}>
          <AccordionFaq items={accordionItems ?? []} name={heading} />
        </Col>
      </Row>
    </StyledContainer>
  );
};

export default AccordionBlock;
